// reducers/partnerReducer.js

import { SET_PARTNER_CONFIG } from "../Action/partnerConfigAction";

const initialState = {
  partnerConfig: null,
};

const partnerConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PARTNER_CONFIG:
      return {
        ...state,
        partnerConfig: action.payload,
      };
    default:
      return state;
  }
};

export default partnerConfigReducer;
